import axios from 'axios'

import { updateOptions } from './helpers'

export default {
  install: (Vue, pluginOptions = {}) => {
    const options = updateOptions(pluginOptions)

    // database
    const $api = axios.create({
      headers: {
        Pragma: 'no-cache' // IE11
      },
      baseURL: options.general
    })

    // static
    const $static = axios.create({
      baseURL: options.static
    })

    const $axios = {
      api: $api,
      static: $static
    }

    Object.defineProperty(Vue.prototype, options.name, { value: $axios })

    return null
  }
}
